<div #pnlDiv [ngClass]="{ 'panes-mb': isHandset, 'over-y': overY && isHandset, 'panes-dt': !isHandset }" [@slide]="activePaneApplied">
  <div [style.width] = 'leftStyleDt' [style.minWidth]="minWidth" >
    <ng-content select="[leftPane]"></ng-content>
  </div>
  <div [style.width] = 'rightStyleDt'>
    <ng-content select="[rightPane]"></ng-content>
  </div>
</div>
<!-- [style.height.px] = 'sliderHt' style="border: 1px red;" -->